export class  returnStatusUrls  {
    SET_DOWNLOAD_STATUS_URL = "ssr/v2/status/set-download-status";
}